import { formatTemperatureC } from "./units.js";
const WEATHER_CONDITION_LABELS = {
    clear: "Clear",
    clear_day: "Clear",
    clear_night: "Clear night",
    partly_cloudy: "Partly cloudy",
    partly_cloudy_day: "Partly cloudy",
    partly_cloudy_night: "Partly cloudy",
    cloudy: "Cloudy",
    rain: "Rain",
    snow: "Snow",
    fog: "Fog",
    heat: "Hot",
    cold: "Cold",
};
export function formatWeatherConditionLabel(condition) {
    const normalized = condition?.trim().toLowerCase();
    if (!normalized)
        return "Weather";
    const known = WEATHER_CONDITION_LABELS[normalized];
    if (known)
        return known;
    const words = normalized.replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
    if (!words)
        return "Weather";
    return words.charAt(0).toUpperCase() + words.slice(1);
}
/**
 * Rewrite a raw weather watching value ("partly_cloudy, 13°C") into display
 * form. Source temperatures are Celsius; pass a locale to render in the
 * viewer's unit, omit it for metric (server-composed strings have no viewer).
 *
 * `system` is the user's stored unit preference and wins over the locale
 * guess when present, so every device the user signs into renders the
 * same unit (SURF-1: phone and desktop disagreed because each derived
 * units from its own browser locale).
 */
export function formatWeatherWatchingValue(value, locale, system) {
    const trimmed = value.trim();
    if (!trimmed)
        return trimmed;
    const tempMatch = /-?\d+(?:\.\d+)?\s*°\s*C?/i.exec(trimmed);
    const temp = tempMatch ? formatTemperature(tempMatch[0], locale, system) : null;
    const condition = trimmed
        .replace(tempMatch?.[0] ?? "", "")
        .replace(/[,.|·]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    const label = condition ? formatWeatherConditionLabel(condition) : null;
    if (temp && label)
        return `${temp} · ${label}`;
    if (label)
        return label;
    if (temp)
        return temp;
    return formatWeatherConditionLabel(trimmed);
}
function formatTemperature(value, locale, system) {
    const numeric = Number.parseFloat(value);
    if (!Number.isFinite(numeric))
        return value.trim();
    return formatTemperatureC(numeric, locale, system);
}
//# sourceMappingURL=weather-presentation.js.map